import React, { Component } from "react"
import LoginView from "./LoginView"
import axios from "axios"

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
    }
  }

  componentDidMount() {
    const code = new URLSearchParams(this.props.location.search).get("code")
    if (code) {
      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded"
      axios
        .post(
          "https://discordapp.com/api/oauth2/token",
          `client_id=${process.env.REACT_APP_CLIENT_ID}&client_secret=${
            process.env.REACT_APP_CLIENT_SECRET
          }&grant_type=authorization_code&code=${code}&scope=identify%20connections%20guilds%20email&redirect_uri=${encodeURIComponent(
            window.location.href.split(/[?#]/)[0]
          )}`
        )
        .then(res => {
           const token = res.data.access_token
          localStorage.setItem("discord_token", res.data.access_token)
      
                axios({
        method: "GET",
        url: `https://discordapp.com/api/users/@me?scope=identify%20email`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(res1 => {
        this.setState({ user: res1.data }, () => {
          axios
            .get(
              `${process.env.REACT_APP_API_URL}/login?id=${this.state.user.id}`
            ).then(ress => {
this.props.history.push("/panel")
            })
        })
      })
          
        })
    } else if (localStorage.getItem("discord_token"))
      this.props.history.push("/panel")
  }

  render() {
    return <LoginView />
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/routes/login/Login.js